import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import type { BlogPost } from "@/data/site/blog";

interface RelatedPostsProps {
  posts: BlogPost[];
  heading?: string;
}

const formatDate = (d: string) =>
  new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const RelatedPosts = ({ posts, heading = "Keep reading" }: RelatedPostsProps) => {
  if (!posts.length) return null;
  return (
    <section className="py-20 bg-secondary/40 border-t border-border">
      <div className="container mx-auto px-4 max-w-5xl">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold mb-3">More from the blog</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-navy mb-10 leading-tight">
          {heading}
        </h2>
        <div className="grid md:grid-cols-3 gap-px bg-border">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              className="group bg-white p-6 flex flex-col hover:bg-secondary/30 transition-colors"
            >
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold mb-2">
                {p.category}
              </span>
              <h3 className="font-heading text-lg font-bold text-navy group-hover:text-gold transition-colors mb-2 leading-snug">
                {p.title}
              </h3>
              <p className="text-sm text-foreground/75 flex-1 line-clamp-3 leading-relaxed">
                {p.excerpt}
              </p>
              <div className="text-xs text-muted-foreground mt-4 pt-4 border-t border-border flex items-center justify-between">
                <span className="flex items-center gap-1">
                  <Calendar className="w-3 h-3" /> {formatDate(p.date)}
                </span>
                <span className="inline-flex items-center gap-1 font-semibold text-navy group-hover:text-gold">
                  Read <ArrowRight className="w-3 h-3" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
